import { render } from "./headermenu.vue?vue&type=template&id=2d6a684b&scoped=true"
import script from "./headermenu.vue?vue&type=script&lang=js"
export * from "./headermenu.vue?vue&type=script&lang=js"

import "./headermenu.vue?vue&type=style&index=0&id=2d6a684b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6a684b"]])

export default __exports__